if (!window.Eurus.loadedScript.has('menu-drawer.js')) {
window.Eurus.loadedScript.add('menu-drawer.js');

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    const safeSetActiveLink = function(linkId) {
      if (!this.currentMenuLinks.includes(linkId)) {
        this.currentMenuLinks.push(linkId);
      }
    };

    const safeScrollTop = function(el = null) {
      const menuNavigation = document.getElementById('menu-navigation');
      if (menuNavigation) {
        menuNavigation.scrollTop = 0;
      }

      const scrollContainer = el?.closest?.('.scrollbar-body');
      if (scrollContainer && scrollContainer !== menuNavigation) {
        scrollContainer.scrollTop = 0;
      }
    };

    Alpine.store('xMenuDrawer', {
      show: false,
      loading: false,
      currentMenuLinks: [],
      open() {
        this.show = true;
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        Alpine.store('xPopup').close();
      },
      setActiveLink: safeSetActiveLink,
      removeActiveLink(linkId) {
        const index = this.currentMenuLinks.indexOf(linkId);
        if (index !== -1) {
          this.currentMenuLinks.splice(index, 1);
        }
      },
      resetMenu() {
        this.currentMenuLinks = [];
      },
      scrollTop: safeScrollTop
    });

    const patchMobileNav = () => {
      const mobileNav = Alpine.store('xMobileNav');
      if (mobileNav) {
        mobileNav.setActiveLink = safeSetActiveLink;
        mobileNav.scrollTop = safeScrollTop;
      }
    };

    patchMobileNav();
    queueMicrotask(patchMobileNav);
  });
});
}
